import type { ComposeBodyDocument } from './types';
import { htmlHasSlateRichFormatting } from './classifyBodyKind';
import {
  resolveUserBodyForPersistence,
  stripLockedComposeBlocksFromUserBody,
  stripTrailingSignatureBlocks,
  trimTrailingEmptyComposeParagraphs,
} from './editorHtml';
import { normalizeQuotedBlock } from './quotedBlockNormalize';

export type BuildComposeDocForPersistenceInput = {
  doc: ComposeBodyDocument;
  liveEditorHtml?: string | null;
};

/** Compose document ready to save as draft (keeps signature + quoted forward/reply). */
export function buildComposeDocForPersistence({
  doc,
  liveEditorHtml,
}: BuildComposeDocForPersistenceInput): ComposeBodyDocument {
  const userBody = stripTrailingSignatureBlocks(
    stripLockedComposeBlocksFromUserBody(
      trimTrailingEmptyComposeParagraphs(
        resolveUserBodyForPersistence(doc.userBody, liveEditorHtml),
        { maxTrailingEmpty: 0 },
      ),
    ),
  );
  const bodyKind = doc.quoted || htmlHasSlateRichFormatting(userBody) ? 'rich' : doc.bodyKind;

  return {
    ...doc,
    bodyKind,
    userBody,
    quoted: doc.quoted ? normalizeQuotedBlock(doc.quoted) : undefined,
  };
}
